import { useTheme, useMediaQuery } from '@mui/material';
import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Button,
  TextField,
  Box,
  Typography,
  FormControl,
  Select,
  FormHelperText,
} from "@mui/material";
import dayjs from "dayjs";
import {
  validateField,
} from "../../common/helpers/validation";
import {
  getGeneralPartyInfoById as getGeneralPartyInfoByIdAction,
  createGeneralPartyInfo as createGeneralPartyInfoAction,
  updateGeneralPartyInfo,
  fetchPriorInsuranceCarriers,
  setGpId
} from "../../redux/actions/generalPartyInfoActions";
import {
  CommonNumbers,
  CommonYesNo,
  leadSource,
  priorbi,
  // priorInsurance,
} from "../../common/StaticFieldList";
import { tabActions } from "../../redux/actions/tabActions";
import { populateValue } from "../../common/helpers/utils";
import DatePickerField from "./DatePickerField";

const requiredFields = ["effectiveDate"];

const validationFunctions = {
};

const GeneralQuote = forwardRef(function GeneralQuote(props, ref) {
  const { handleNext, handleBack, data, id } = props;
  const theme = useTheme();
  const getGpId = useSelector((state) => state.generalPartyInfo.gpId)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const dispatch = useDispatch();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  let quoteId = getGpId;
  const priorInsuranceCarriers = useSelector(
    (state) => state.priorInsuranceCarriers.priorInsuranceCarriers
  );
  const dynamicTheme = useSelector((state) => state?.theme?.theme[0]);
  const userid = useSelector((state) => state?.user?.user?.id);

  useEffect(() => {
    dispatch(fetchPriorInsuranceCarriers());
  }, [dispatch]);

  let priorInsuranceCarriersOptionss = [];
  if (Array.isArray(priorInsuranceCarriers)) {
    priorInsuranceCarriersOptionss = priorInsuranceCarriers.map((carrier) => ({
      value: carrier.carrierName,
      label: carrier.carrierName,
    }));
  }

  const validationRulesGeneral = [
    {
      fieldName: "effectiveDate",
      label: "Policy Effective Date",
      type: "text",
      format: "mm/dd/yyyy",
      id: "effectivedate"
    },
    {
      fieldName: "policyTerms",
      label: "Policy Terms",
      type: "select",
      option: CommonNumbers,
      id: "policyterms",
        defaultValue: "6",
    },
    {
      fieldName: "priorInsuranceCarrier",
      label: "Prior Insurance Carrier",
      type: "select",
      option: priorInsuranceCarriersOptionss,
      id: "priorinsurancecarrier"
    },
    // {
    //   fieldName: "priorInsurance",
    //   label: "Prior Insurance",
    //   type: "select",
    //   option: priorInsurance,
    //   id: "priorinsurance"
    // },

    {
      fieldName: "priorExpirationDate",
      label: "Prior Carrier End Date",
      type: "text",
      id: "priorexpirationdate"
    },
    {
      fieldName: "priorBI",
      label: "Prior Liability BI",
      type: "select",
      option: priorbi,
      id: "priorBI"
    },
     {
      fieldName: "priorpolicyTerms",
      label: "Prior Policy Terms",
      type: "number",
      // option: CommonNumbers,
      id: "policyterms"
    },
    {
      fieldName: "leadSource",
      label: "Lead Source",
      type: "select",
      option: leadSource,
      id: "leadsource"
    },

    {
      fieldName: "allowCreditScore",
      label: "Is Credit check allowed?",
      type: "select",
      option: CommonYesNo,
      defaultValue: "Y",
      id: "allowedcreditscore"
    },
  ];

  const newFieldArg = [...validationRulesGeneral];

  const [formState, setFormState] = useState(() => {
    const initialState = {
      formData: newFieldArg.reduce(
        (fields, { fieldName, defaultValue }) => ({
          ...fields,
          [fieldName]: defaultValue || "",
        }),
        {}
      ),
      touchedFields: newFieldArg.reduce(
        (fields, { fieldName }) => ({
          ...fields,
          [fieldName]: false,
        }),
        {}
      ),
      fieldErrors: newFieldArg.reduce(
        (errors, { fieldName }) => ({
          ...errors,
          [fieldName]: "",
        }),
        {}
      ),
    };

    initialState.formData.allowCreditScore = "Y";
    return initialState;
  });

  useEffect(() => {
    if (id) {
      dispatch(getGeneralPartyInfoByIdAction(id));
    }
  }, []);

  useEffect(() => {
    if (quoteId) {
      dispatch(getGeneralPartyInfoByIdAction(quoteId));
    }
  }, []);

  const generalPartyInfo = useSelector(
    (state) => state.generalPartyInfo.allGeneralPartyInfo
  );
  const { formData, touchedFields, fieldErrors } = formState;
const shouldShowPriorFields = () => {
  const priorCarrierValue = formData.priorInsuranceCarrier;
  return priorCarrierValue &&
         priorCarrierValue !== "" &&
         priorCarrierValue.toLowerCase() !== "no prior";
};
  // const handleInputChange = (e) => {
  //   e.preventDefault();
  //   const { name, value } = e.target;
  //   setFormState((prevState) => ({
  //     ...prevState,
  //     formData: {
  //       ...prevState.formData,
  //       [name]: value,
  //     },
  //   }));
  // };
  const handleInputChange = (e) => {
  e.preventDefault();
  const { name, value } = e.target;

  let updatedFormData = {
    ...formState.formData,
    [name]: value,
  };

  // Clear prior fields when priorInsuranceCarrier is changed to empty or "No Prior"
  if (name === 'priorInsuranceCarrier') {
    const shouldShow = value && value !== "" && value.toLowerCase() !== "no prior";
    if (!shouldShow) {
      updatedFormData = {
        ...updatedFormData,
        priorExpirationDate: "",
        priorBI: "",
        priorpolicyTerms: "",
      };
    }
  }

  setFormState((prevState) => ({
    ...prevState,
    formData: updatedFormData,
  }));
};

  const handleDateChange = (date, fieldName) => {
    const formattedDate = date && dayjs(date).isValid() ? dayjs(date).format("MM-DD-YYYY") : "";
    const customEvent = {
      preventDefault: () => {},
      target: {
        name: fieldName,
        value: formattedDate,
      },
    };
    handleInputChange(customEvent);
  };

  const handleBlur = (field) => {
    setFormState((prevFormState) => ({
      ...prevFormState,
      touchedFields: {
        ...prevFormState.touchedFields,
        [field]: true,
      },
    }));

    if (!requiredFields.includes(field)) {
      return;
    }

    const value = formData[field];
    const error = validateField(
      value,
      newFieldArg.find((rule) => rule.fieldName === field).label
    );

    const additionalError = validationFunctions[field]
      ? validationFunctions[field](value)
      : "";

    setFormState((prevFormState) => ({
      ...prevFormState,
      fieldErrors: {
        ...prevFormState.fieldErrors,
        [field]: error || additionalError,
      },
    }));
  };

  const handleSnackbarOpen = (message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const isValidDateFormat = (dateString) => {
      if (!dateString) return true;
      const dateRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{4}$/;
      return dateRegex.test(dateString) && dayjs(dateString, 'MM-DD-YYYY').isValid();
    };

    const validationErrors = newFieldArg.reduce(
      (errors, { fieldName, label }) => {
        if (requiredFields.includes(fieldName)) {
          const value = formData[fieldName];
          let error = validateField(value, label);

          if (!error && (fieldName === 'effectiveDate' || fieldName === 'priorExpirationDate')) {
            if (!isValidDateFormat(value)) {
              error = 'Please enter date in MM-DD-YYYY format';
            }
          }

          const additionalError = validationFunctions[fieldName]
            ? validationFunctions[fieldName](value)
            : "";

          setFormState((prevFormState) => ({
            ...prevFormState,
            fieldErrors: {
              ...prevFormState.fieldErrors,
              [fieldName]: error || additionalError,
            },
          }));

          return {
            ...errors,
            [fieldName]: error || additionalError,
          };
        }
        return errors;
      },
      {}
    );

    const hasErrors = Object.values(validationErrors).some((error) => !!error);

    if (!hasErrors) {
      try {
        const formattedFormData = {
          ...formData,
          effectiveDate: formData.effectiveDate
            ? dayjs(formData.effectiveDate, 'MM-DD-YYYY').format('MM-DD-YYYY')
            : "",
          priorExpirationDate: formData.priorExpirationDate
            ? dayjs(formData.priorExpirationDate, 'MM-DD-YYYY').format('MM-DD-YYYY')
            : "",
        };

        if (quoteId || id) {
          const newFormData = {
            ...formattedFormData,
            ...data,
            gpId: id ? parseInt(id) : parseInt(quoteId),
            createdBy: userid,
            clientCustomerId: generalPartyInfo.clientCustomerId,
          };
          await dispatch(
            updateGeneralPartyInfo(newFormData, getCreateUserSuccess)
          );
        } else {
          const newFormData = {
            ...formattedFormData,
            ...data,
          };
          await dispatch(
            createGeneralPartyInfoAction(newFormData, getCreateUserSuccess)
          );
        }
      } catch (error) {
        handleSnackbarOpen(
          error.message || "User service failed. Please try again.",
          "error"
        );
      }
    } else {
      handleSnackbarOpen(
        "Validation errors detected. Please correct them.",
        "error"
      );
    }
    handleNext();
  };

  const getCreateUserSuccess = async (uid) => {
    handleSnackbarOpen("Created successfully.", "success");
    await dispatch(setGpId(uid))
    await dispatch(tabActions(1));
  };

  useEffect(() => {
    if (generalPartyInfo) {
      setFormState((prevFormState) => ({
        ...prevFormState,
        formData: newFieldArg.reduce(
          (fields, { fieldName, defaultValue }) => {
            const populatedValue = populateValue(
              generalPartyInfo[fieldName],
              fieldName,
              newFieldArg
            );
            let valueToUse;
            if (populatedValue) {
              valueToUse = populatedValue;
            } else if (fieldName === "allowCreditScore") {
              valueToUse = "Y";
            }
            else if (fieldName === "policyTerms") {
              valueToUse = "6";
            }
            else {
              valueToUse = defaultValue || "";
            }
            return {
              ...fields,
              [fieldName]: valueToUse,
            };
          },
          {}
        ),
      }));
    }
  }, [generalPartyInfo]);

  const isDirty = () => Object.values(touchedFields || {}).some(Boolean);

  const isFormValid = () => {
    const allRequiredFieldsFilled = requiredFields.every((fieldName) => {
      const value = formData[fieldName];
      return value && value.toString().trim() !== "";
    });
    const noValidationErrors = requiredFields.every(
      (fieldName) => !fieldErrors[fieldName]
    );
    return allRequiredFieldsFilled && noValidationErrors;
  };

  const doResetForm = () => {
    const empty = newFieldArg.reduce((acc, {fieldName, defaultValue}) => {
      acc[fieldName] = defaultValue || (fieldName === "allowCreditScore" ? "Y" : "");
      return acc;
    }, {});
    setFormState({
      formData: empty,
      touchedFields: newFieldArg.reduce((m, {fieldName}) => ({...m,[fieldName]:false}),{}),
      fieldErrors: newFieldArg.reduce((m, {fieldName}) => ({...m,[fieldName]:""}),{}),
    });
  };

  const saveWithoutNav = async () => {  
   // validate required only
   const errors = newFieldArg.reduce((errs, {fieldName, label}) => {
     if (!requiredFields.includes(fieldName)) return errs;
     const v = formData[fieldName];
     let e = validateField(v, label);
     if (!e && (fieldName === 'effectiveDate' || fieldName === 'priorExpirationDate')) {
       const re = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{4}$/;
       if (!(v && re.test(v) && dayjs(v, 'MM-DD-YYYY').isValid())) e = 'Please enter date in MM-DD-YYYY format';
     }
     return {...errs, [fieldName]: e};
   }, {});
   setFormState(p => ({...p, fieldErrors: {...p.fieldErrors, ...errors}}));
   if (Object.values(errors).some(Boolean)) return {ok:false};

   try {
     const formatted = {
       ...formData,
       effectiveDate: formData.effectiveDate ? dayjs(formData.effectiveDate, 'MM-DD-YYYY').format('MM-DD-YYYY') : "",
       priorExpirationDate: formData.priorExpirationDate ? dayjs(formData.priorExpirationDate, 'MM-DD-YYYY').format('MM-DD-YYYY') : "",
     };
     if (quoteId || id) {
       const payload = {
         ...formatted, ...data,
         gpId: id ? parseInt(id) : parseInt(quoteId),
         createdBy: userid,
         clientCustomerId: generalPartyInfo.clientCustomerId,
       };
       await dispatch(updateGeneralPartyInfo(payload, getCreateUserSuccess));
     } else {
       await dispatch(createGeneralPartyInfoAction({...formatted, ...data}, getCreateUserSuccess));
     }
     return {ok:true};
   } catch(e) {
     return {ok:false};
   }
 };

 useImperativeHandle(ref, () => ({
   shouldConfirm: () => isDirty() && isFormValid(),
   saveWithoutNav,
   resetForm: doResetForm,
 }));

  return (
    <>
      <Box
        sx={{
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "36px",
          maxWidth: "100%",
          padding: isMobile ? "0 16px" : "0",
          // Add only the height-related styles from the second Box
          minHeight: '40vh',
          '@media (min-width: 768px) and (max-width: 1024px)': {
            minHeight: '80vh',
            height: 'auto',
            overflowY: 'auto',
          },
          '@media (min-width: 1024px) and (min-height: 1366px)': {
            height: 'auto',
            minHeight: '100vh',
          },
        }}
      >
        <Box
          id="form"
          component="form"
          onSubmit={handleSubmit}
          sx={{
            width: isMobile ? "100%" : isTablet ? "90%" : "853px",
            borderRadius: "4px",
            backgroundColor: "#fff",
            border: "1px solid #e3e3e3",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "30px 0px 24px",
            gap: "23px",
            maxWidth: "100%",
          }}
        >
          <Typography
            id="generalquoteinformation"
            variant="h1"
            component="div"
            sx={{
              border: "none",
              backgroundColor: "transparent",
              alignSelf: "stretch",
              height: "51px",
              fontFamily: '"Poppins", sans-serif',
              fontWeight: "600",
              fontSize: isMobile ? "20px" : "25px",
              color: "#242929",
              paddingLeft: isMobile ? "20px" : "50px",
              display: "flex",
              alignItems: "center",
            }}
          >
            General Quote Information
          </Typography>
          <hr style={{ borderTop: "1px solid #ccc", width: "100%" }} />
          <Box
            sx={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "flex-end",
              padding: isMobile ? "0px 16px" : "0px 44px 0px 55px",
              boxSizing: "border-box",
              maxWidth: "100%",
              fontFamily: '"Poppins", sans-serif',
            }}
          >
            <Box
              sx={{
                flex: "1",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: "16px",
                maxWidth: "100%",
                fontFamily: '"Poppins", sans-serif',
              }}
            >
              <Box
                sx={{
                  flex: "1",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  gap: "4px",
                  minWidth: isMobile ? "100%" : "240px",
                  fontFamily: '"Poppins", sans-serif',
                  maxWidth: "100%",
                }}
              >
                <Box
                  sx={{
                    alignSelf: "stretch",
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                    gap: "5px 20px",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    padding: "0px 0px 8px",
                  }}
                >
                  {validationRulesGeneral.map(
                    (
                      { fieldName, label, defaultValue, type, option },
                      index
                    ) => {
                       if (['priorExpirationDate', 'priorBI', 'priorpolicyTerms'].includes(fieldName) &&
                              !shouldShowPriorFields()) {
                            return null;
                          }
                      return (
                      <React.Fragment key={index}>
                        <Box
                          sx={{
                            display: "flex",
                            flexFlow: "column",
                            margin: "0 0 15px 0",
                            width: "100%",
                          }}
                          key={index}
                        >
                          <Typography
                            key={fieldName}
                            variant="body1"
                            sx={{
                              position: "relative",
                              lineHeight: "40px",
                              fontWeight: "500",
                              display: "inline-block",
                              minWidth: "83px",
                              zIndex: "1",
                              fontFamily: '"Poppins", sans-serif',
                            }}
                          >
                            {label}
                            {requiredFields.includes(fieldName) && (
                              <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                            )}
                          </Typography>
                          {fieldName === "effectiveDate" ? (
                            <DatePickerField
                              fieldName="effectiveDate"
                              formData={formData}
                              handleDateChange={handleDateChange}
                              handleBlur={handleBlur}
                              touchedFields={touchedFields}
                              fieldErrors={fieldErrors}
                              size={isMobile ? "small" : "medium"}
                            />
                          ) : fieldName === "priorExpirationDate" ? (
                            <DatePickerField
                              fieldName="priorExpirationDate"
                              formData={formData}
                              handleDateChange={handleDateChange}
                              handleBlur={handleBlur}
                              touchedFields={touchedFields}
                              fieldErrors={fieldErrors}
                              size={isMobile ? "small" : "medium"}
                            />
                          ) : type === "select" ? (
                            <FormControl
                              fullWidth
                              variant="outlined"
                              sx={{
                                border: "none",
                                backgroundColor: "transparent",
                                alignSelf: "stretch",
                                fontFamily: '"Poppins", sans-serif',
                                fontWeight: "500",
                                fontSize: "16px",
                                zIndex: "1",
                              }}
                              size={isMobile ? "small" : "medium"}
                            >
                              <Select
                                native
                                name={fieldName}
                                value={formData[fieldName] || ""}
                                onChange={(e) => {
                                  handleInputChange(e);
                                }}
                                error={touchedFields[fieldName] && !!fieldErrors[fieldName]}
                                displayEmpty
                                inputProps={{ 'aria-label': label }}
                                sx={{
                                  height: isMobile ? "40px" : "55px",
                                  "& .MuiInputBase-root": {
                                    height: isMobile ? "40px" : "55px",
                                    backgroundColor: "#fff",
                                    fontSize: "14px",
                                    fontFamily: '"Poppins", sans-serif',
                                  },
                                  "& .MuiInputBase-input": {
                                    color: dynamicTheme?.secondaryColor,
                                    fontFamily: '"Poppins", sans-serif',
                                  },
                                  "& fieldset": {
                                    borderColor: touchedFields[fieldName] && !!fieldErrors[fieldName]
                                      ? "#d32f2f"
                                      : "#C1C1C1",
                                    fontFamily: '"Poppins", sans-serif',
                                  },
                                }}
                              >
                                <option value="" disabled>
                                  Select {label}
                                </option>
                                {option && option.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </Select>
                              {touchedFields[fieldName] && fieldErrors[fieldName] && (
                                <FormHelperText error>
                                  {fieldErrors[fieldName]}
                                </FormHelperText>
                              )}
                            </FormControl>
                          ) : (
                            <TextField
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                                alignSelf: "stretch",
                                height: isMobile ? "40px" : "55px",
                                fontFamily: '"Poppins", sans-serif',
                                fontWeight: "500",
                                fontSize: "14px",
                                color: "#242929",
                                zIndex: "1",
                              }}
                              type={type}
                              variant="outlined"
                              defaultValue={formData[fieldName]}
                              select={type === "select"}
                              required={requiredFields.includes(fieldName)}
                              id={fieldName}
                              placeholder={label}
                              name={fieldName}
                              autoComplete={fieldName}
                              value={formData[fieldName]}
                              // onChange={(e) => handleInputChange(e)}
                              onChange={(e) => {
                                  // Special handling for priorpolicyTerms field
                                  if (fieldName === "priorpolicyTerms") {
                                    const value = e.target.value;
                                    // Only allow numeric input and limit to 2 digits
                                    if (/^\d{0,2}$/.test(value)) {
                                      handleInputChange(e);
                                    }
                                  } else {
                                    handleInputChange(e);
                                  }
                                }}
                              onBlur={() => handleBlur(fieldName)}
                              error={
                                touchedFields[fieldName] &&
                                !!fieldErrors[fieldName]
                              }
                              helperText={
                                touchedFields[fieldName]
                                  ? fieldErrors[fieldName]
                                  : ""
                              }
                              size={isMobile ? "small" : "medium"}
                              sx={{
                                "& fieldset": {
                                  borderColor: "#C1C1C1",
                                  fontFamily: '"Poppins", sans-serif',
                                },
                                "& .MuiInputBase-root": {
                                  height: isMobile ? "40px" : "55px",
                                  backgroundColor: "#fff",
                                  fontSize: isMobile ? "14px" : "16px",
                                  fontFamily: '"Poppins", sans-serif',
                                },
                                "& .MuiInputBase-input": {
                                  color: "#242929",
                                  fontFamily: '"Poppins", sans-serif',
                                },
                              }}
                            >
                            </TextField>
                          )}
                        </Box>
                      </React.Fragment>
                      )
                      }
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "222px",
              height: "42px",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              gap: "14px",
              fontFamily: '"Poppins", sans-serif',
            }}
          >
            <Button
              startIcon={<ArrowBackIosIcon />}
              disableElevation={true}
              variant="outlined"
            >
              Back
            </Button>

            <Button
              type="submit"
              disabled={!isFormValid()}
              endIcon={<ArrowForwardIosIcon />}
              disableElevation={true}
              variant="outlined"
              id="nextbutton"
            >
              Next
            </Button>
          </Box>
          <Box
            sx={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "center",
              padding: "20px 20px 50px 23px",
              fontFamily: '"Poppins", sans-serif',
            }}
          >
            <Button
              disableElevation={true}
              variant="contained"
              id="continuebutton"
              onClick={handleSubmit}
               disabled={!isFormValid()}
              size={isMobile ? "small" : "large"}
            >
              Continue
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
});

export default GeneralQuote;